id,name,category,image,counter,start,bar,shape,size,effect,full_at
damage,Damage Counter,damage,,yes,1,,round,,,
sp-decay,SP Decay,damage,,yes,1,,round,,,
destroyed,Destroyed,damage,,no,,,round,,,
gerzite,Gerzite,resource,gerzite.png,no,,gerzite,cutout,,,
dark-gerzite,Dark Gerzite,resource,darkgerzite.png,no,,dark,cutout,,,
status-1,Status Token 1,status,,no,,,round,,,
status-2,Status Token 2,status,,no,,,round,,,
status-3,Status Counter,status,,yes,1,,round,,,
misc-1,Misc Token 1,misc,,no,,,round,,,
misc-2,Misc Counter,misc,,yes,0,,round,,,
tier-2,Tier II,tier,,no,,,round,,,
tier-3,Tier III,tier,,no,,,round,,,
darkgale,Darkgale,misc,,no,,,round,,,
fractal,Fractal,resource,fractal.png,yes,1,,cutout,,,
flying,Flying,misc,,no,,,round,,,
ground,Ground,misc,,no,,,round,,,
lanespanner,Lanespanner,misc,,no,,,round,,,
timer-start,Start of Turn Timer,misc,,yes,2,,round,,,
timer-end,End of Turn Timer,misc,,yes,2,,round,,,
timer-up,Count-Up Timer,misc,,yes,0,,round,,,
count,Count,misc,,yes,1,,round,,,
range,Range,damage,,yes,1,,round,,,5
shield,Shield,damage,,yes,1,,round,,,5
gerzite-shield,Gerzite Shield,damage,,yes,1,,round,,shield,5
thorns,Thorns,damage,,yes,1,,round,,,5
health,Health,damage,,yes,1,,round,,,5
direct,Direct,damage,,no,,,round,,direct,
pierce,Pierce,damage,,no,,,round,,pierce,
target,Target,damage,,no,,,round,,target,
link,Link,misc,,yes,1,,round,,,
splash,Splash,misc,,no,,,round,,,
bell,Bell,misc,,no,,,round,,bell,
transmission,Transmission,misc,,yes,4,,round,,transmission,
resource,Harvest,misc,,yes,1,,round,,resource,
life-bank,Life Bank,misc,,yes,3,,round,,life-bank,
bleed,Bleed,status,,yes,1,,round,,,
buffer,Buffer,status,,yes,1,,round,,,7
burn,Burn,status,,no,,,round,,,
comatose,Comatose,status,,yes,1,,round,,,
crumble,Crumble,status,,no,,,round,,,
damage-boost,Damage Boost,status,,yes,1,,round,,,6
decay,Decay,status,,yes,1,,round,,,6
divinity,Divinity,status,,yes,1,,round,,,
frenzy,Frenzy,status,,yes,1,,round,,,
frozen,Frozen,status,,yes,1,,round,,,4
locked,Locked,status,,no,,,round,,,
overclock,Overclock,status,,yes,1,,round,,,6
overheal,Overheal,status,,yes,1,,round,,,6
overshield,Overshield,status,,yes,1,,round,,,6
possession,Possession,status,,yes,1,,round,,,
regeneration,Regeneration,status,,yes,1,,round,,,
entrenched,Entrenched,status,,yes,1,,round,,,
stunned,Stunned,status,,no,,,round,,,
susceptible,Susceptible,status,,yes,1,,round,,,5
ambush,Ambush,status,,no,,,round,,,
weakness,Weakness,status,,yes,1,,round,,,5
die-blue,Blue Die,dice,,no,,,round,,,
die-red,Red Die,dice,,no,,,round,,,
special-hit,Special Hit,damage,,no,,,round,,special-hit,
aff-duned,Duned,affiliation,,no,,,round,,aff-duned,
aff-forested,Forested,affiliation,,no,,,round,,aff-forested,
aff-frigid,Frigid,affiliation,,no,,,round,,aff-frigid,
aff-magical,Magical,affiliation,,no,,,round,,aff-magical,
aff-spectral,Spectral,affiliation,,no,,,round,,aff-spectral,
aff-submerged,Submerged,affiliation,,no,,,round,,aff-submerged,
aff-undead,Undead,affiliation,,no,,,round,,aff-undead,
aff-volcanic,Volcanic,affiliation,,no,,,round,,aff-volcanic,
aff-astral,Astral,affiliation,,no,,,round,,aff-astral,
aff-neutral,Neutral,affiliation,,no,,,round,,aff-neutral,
